import { Api, Error, FullRequestParams, HttpResponse } from "./kmsApi";
import { findUrlParts } from "./api.utils";

export let rootKMSApi = new Api();
// api.baseUrl = `/api/obs/${api.baseUrl}`;
const internalRequestFunc = rootKMSApi.request;
rootKMSApi.request = async <T = any, E = any>({
  body,
  secure,
  path,
  type,
  query,
  format,
  baseUrl,
  cancelToken,
  ...params
}: FullRequestParams): Promise<HttpResponse<T, E>> => {
  const urlParts = findUrlParts(window.location.href.split("/"), [
    "sites",
    "keyManager",
  ]);

  const siteId = urlParts[0];
  const resourceID = urlParts[1];

  baseUrl = `/api/route/${siteId}/key_manager/${resourceID}${rootKMSApi.baseUrl}`;
  const internalResp = internalRequestFunc({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params,
  });
  return internalResp.then(CommonAPIValidation);
};

export function CommonAPIValidation<D, E>(
  res: HttpResponse<D, E>,
): HttpResponse<D, E> {
  const err = res.error as Error;
  if (err && err.code === 403 && err.message === "invalid session") {
    document.location = "/";
  }
  return res;
}
